import { Card, CardContent, CircularProgress, Grid, Typography } from '@mui/material';
import React from 'react';
import TransitionsTable from '../../../../components/transition/TransitionsTable';
import { Transition } from '../../../../interface/Transition';
import { ProcessInstance } from '../../../../interface/ProcessInstance';

type Props = {
  processInstance: ProcessInstance;
  loading: boolean;
  error: boolean;
  onClick?: any;
};

export const TransitionDetails = ({ processInstance, loading, error, onClick }: Props) => (
  <Grid item xs={12} lg={8}>
    <Card>
      <CardContent>
        <Grid container spacing={1}>
          {/* ------------------------- row 1 ------------------------- */}
          <Grid item xs={12} sx={{ mb: 2 }}>
            <Typography component="span" variant="h2">
              Transition Details
            </Typography>
          </Grid>
          <Grid item xs={12}>
            {!loading || !error ? (
              <TransitionsTable transitions={processInstance.transitions} onClick={onClick} />
            ) : (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  marginTop: '20px',
                  width: '100%',
                }}
              >
                <CircularProgress className="animate__animated animate__fadeIn" />
              </div>
            )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  </Grid>
);
